import { Box, Typography, useTheme } from '@mui/material'
import { FeatureSection } from './FeatureSection'
import data from '../../data/data.json'

export function FeaturesFullPage() {
  const theme = useTheme()

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4)
    }}>
      {/* Header */}
      <Box sx={{ mb: 4, textAlign: 'center', pt: 4 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 700,
            fontSize: { xs: '2rem', sm: '2.5rem' },
            background: theme.palette.mode === 'dark'
              ? 'linear-gradient(135deg, #a7c2fd 0%, #7c9ffc 100%)'
              : 'linear-gradient(135deg, #3560c1 0%, #0037b1 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.02em',
          }}
        >
          Platform Features
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontSize: { xs: '0.875rem', sm: '1rem' },
            maxWidth: 500,
            mx: 'auto',
          }}
        >
          Core capabilities of {data.project.name}
        </Typography>
      </Box>

      {/* Feature Sections */}
      {data.features.map((feature, index) => (
        <FeatureSection
          key={feature.id}
          feature={feature}
          imagePosition={index % 2 === 0 ? 'left' : 'right'}
          isEven={index % 2 === 0}
        />
      ))}
    </Box>
  )
}
